<div>
  <ng-container *ngIf="showDudaSsoUrl">
    <app-duda-site-admin-sso-button [showSiteInfo]="true">
    </app-duda-site-admin-sso-button>
  </ng-container>
  <ng-container *ngIf="showBoostSiteAccounts">
    <app-components-specialist-boost-site-accounts-read-only [customerId]="customer.CustomerId">
    </app-components-specialist-boost-site-accounts-read-only>
  </ng-container>
  <ul class="list-group">
    <ng-container *ngFor="let customerAccount of customerAccounts">
      <app-components-specialist-customer-account-read-only
        [customerAccount]="customerAccount"
        (customerAccountChange)="onCustomerAccountChanged($event)"
        class="list-group-item">
      </app-components-specialist-customer-account-read-only>
    </ng-container>
  </ul>
</div>